import { FC, ButtonHTMLAttributes } from 'react';
import Icon from '../Icon/Icon';
import { LucideIcon } from 'lucide-react';
import './Button.css';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary';
  icon?: keyof Omit<typeof import('lucide-react'), 'createLucideIcon'>;
  iconPosition?: 'left' | 'right';
  label?: string;
  size?: 'sm' | 'md' | 'lg';
}

const Button: FC<ButtonProps> = ({ 
  children, 
  variant = 'primary', 
  size = 'md',
  icon,
  iconPosition = 'left',
  label,
  className = '',
  ...props 
}) => {

  const buttonClass = !children && icon ? 'button--icon' : '';

  return (
    <button
      className={`button ${variant} ${buttonClass} ${className}`}
      {...props}
    >
      {icon && iconPosition === 'left' && (
        <Icon name={icon} className="button-icon button-icon-left" />
      )}
      {children}
      {icon && iconPosition === 'right' && (
        <Icon name={icon} className="button-icon button-icon-right" />
      )}
      {label && <span className="screen-reader-text">{label}</span>}
    </button>
  );
};

export default Button; 